import fetchClient from './fetchClient';

import { errorHandler } from './utils';


const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getPaginatedSuppliers = async (
    page: number,
    limit: number,
    search: string,
) => {
    const res: any = await fetchClient
        .get(
            `/suppliers?limit=${limit}&page=${page}&search=${search}`,
            config(),
        )
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getSuppliers = async () => {
    const res: any = await fetchClient
        .get('/suppliers?limit=5000', config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getSupplier = async (id: string) => {
    const res = await fetchClient.get(`/suppliers/${id}`, config()).catch((err) => {
        return null;
    });
    if (!res) return null;
    return res.data;
};

export const getSupplierPage = async (id: string) => {
    const res = await fetchClient
        .get(`/suppliers/page/${id}`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getCustomerLastOrder = async (id: string) => {
    const res = await fetchClient
        .get(`/customers/${id}/lastOrder`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const updateSupplier = async (customer: any) => {
    const id = customer._id;
    delete customer._id;
    const res: any = await fetchClient
        .put(`/suppliers/${id}`, customer, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const archiveSupplier = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/suppliers/${id}/archive`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const deleteSuppliers = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/suppliers/${id}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const createSupplier = async (customer: any) => {
    const res = await fetchClient
        .post('/suppliers', customer, config())
        .catch(errorHandler);
    return res.data;
};


export const getSupplierProducts = async (supplierId: string) => {
    try {
      const res = await fetch(`/api/suppliers/${supplierId}/products`, {
        credentials: 'include',
      });
      if (!res.ok) return [];
      return await res.json();
    } catch (e) {
      console.error('Failed to fetch supplier products', e);
      return [];
    }
  };

  export const addProductToSupplier = async (supplierId: string, productId: string) => {
    return fetchClient.post(`/suppliers/${supplierId}/products/${productId}`, {}, config());
  };
  
  export const removeProductFromSupplier = async (supplierId: string, productId: string) => {
    return fetchClient.delete(`/suppliers/${supplierId}/products/${productId}`, config());
  };
  